<style lang="scss" src='./AlertMap.scss' scoped></style>
<template src="./AlertMap.html"></template>

<script>
import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';
import MapStation from '@/assets/img/ic/ico_marker_station.png';

export default {
  name: 'AlertMap',
  props: {
    sensor: {
      required: false,
    },
    station: {
      required: false,
    },
  },
  data() {
    return ({
      map: {},
      google: {},
    });
  },
  computed: {
    valid() {
      let coordinates = {latitude: 0, longitude: 0}
      
      if (this.sensor && this.sensor.latitude){
        coordinates = this.sensor; 
      } else if (this.station && this.station.latitude){
        coordinates = this.station; 
      }

      if(coordinates.longitude && coordinates.latitude && this.G_validateLatLong(coordinates.latitude, coordinates.longitude)){
        return true
      }
      return false
    },
  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && (!oldSensor || newSensor.sensor_id !== oldSensor.sensor_id)) {
        this.loadData();
      }
    },
    station: function (newStation, oldStation) {
      if (newStation && (!oldStation || newStation.station_id !== oldStation.station_id)) {
        this.loadData();
      }
    }
  },
  methods: {

    async initMap({latitude, longitude}) {
      const position = {
        lat: latitude,
        lng: longitude
      };

      const mapOptions = {
        mapId: 'map',
        zoom: 18,
        center: position,
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;

      let mapIcon = MapRedFlag;

      if (this.station && this.station.station_id) {
        mapIcon = {
          url: MapStation,
          scaledSize: new google.maps.Size(100, 75),
        }
      }

      const newMark = new window.google.maps.Marker({
        position,
        icon: mapIcon,
      });

      if (this.map && this.google && this.google.maps) {
        newMark.setAnimation(this.google.maps.Animation.BOUNCE);
        newMark.setMap(this.map);

        // eslint-disable-next-line
        setTimeout(function () {
          newMark.setAnimation(null);
        }, 1500);
      }
    },

    loadData() {
      let coordinates = {latitude: 0, longitude: 0}
      if (this.sensor && this.sensor.latitude){
        coordinates = this.sensor; 
      } else if (this.station && this.station.latitude){
        coordinates = this.station; 
      }
      
      if(this.G_validateLatLong(coordinates.latitude, coordinates.longitude)){
        this.initMap(coordinates);
      }
    },

  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.loadData();
  },
};
</script>
